import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import './UnifiedFormStyles.css';

const PromotionalActivity = ({ navigation, primaryDetails, setPrimaryDetails }) => {
  const [selectedActivity, setSelectedActivity] = useState(
    primaryDetails?.promotional_activity || ''
  );
  const [errors, setErrors] = useState({});

  // Sync to primaryDetails whenever selectedActivity changes
  useEffect(() => {
    setPrimaryDetails((prev) => ({
      ...prev,
      promotional_activity: selectedActivity,
    }));
  }, [selectedActivity]);

  const activities = [
    { id: 'cip_rollout', label: 'CIP Rollout' },
    { id: 'incentive_verification', label: 'Incentive Verification' },
    { id: 'awarding_merienda', label: 'Awarding Merienda' },
    { id: 'awarding_maya_credits', label: 'Awarding Maya Credits' },
    { id: 'awarding_flagship_store', label: 'Awarding Flagship Store' }
  ];

  const handleActivityChange = (value) => {
    setSelectedActivity(value);
    if (errors.promotional_activity) {
      setErrors((prev) => ({ ...prev, promotional_activity: false }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!selectedActivity) {
      newErrors.promotional_activity = 'Please select a promotional activity';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isFormValid = () => {
    return !!selectedActivity;
  };
  const handleBack = () => {
    if (navigation && navigation.previous) navigation.previous();
  };

  const handleNext = () => {
    if (!validate()) {
      toast.error('Please select a promotional activity', {
        autoClose: 3000,
        hideProgressBar: true,
        theme: 'colored',
      });
      return;
    }

    // Navigate based on selected activity
    if (navigation && navigation.go) {
      if (selectedActivity === 'incentive_verification') {
        navigation.go('maya-account-details');
      } else if (selectedActivity === 'awarding_merienda') {
        navigation.go('awarding-merienda');
      } else if (selectedActivity === 'awarding_maya_credits') {
        navigation.go('awarding-maya-credit');
      } else if (selectedActivity === 'awarding_flagship_store') {
        navigation.go('awarding-flagship');
      } else {
        navigation.go('maya-mall-program-section-70');
      }
    }
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Promotional Activity</h4>
              <p className="form-desc">Please select the promotional activity</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Activity <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {activities.map((activity) => (
                        <div
                          key={activity.id}
                          className={`form-radio-item ${selectedActivity === activity.id ? 'selected' : ''}`}
                          onClick={() => handleActivityChange(activity.id)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="promotional_activity"
                              label={activity.label}
                              value={activity.id}
                              checked={selectedActivity === activity.id}
                              onChange={(e) => handleActivityChange(e.target.value)}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.promotional_activity && (
                      <div className="form-error">{errors.promotional_activity}</div>
                    )}
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary" disabled={!isFormValid()}>
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PromotionalActivity;
